var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loading-wrapper text-center py-5" }, [
    _c(
      "div",
      { staticClass: "w-100" },
      [
        _c("b-spinner", {
          staticClass: "spinner",
          attrs: { label: "loading", type: _vm.type, variant: _vm.variant },
        }),
      ],
      1
    ),
    _c("span", [_vm._v(_vm._s(_vm.$t("frases.loading")))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }